import {
  CanonicalContact,
  ContactRole,
  KNOWN_ROLES,
} from './contactShape';

export interface GroupedContacts {
  role: ContactRole;
  contacts: CanonicalContact[];
}

const GROUP_ORDER: readonly ContactRole[] = [
  ...KNOWN_ROLES,
  'Unrecognized',
];

export const groupByRole = (
  contacts: CanonicalContact[]
): GroupedContacts[] => {
  if (!contacts || contacts.length === 0) {
    return [];
  }

  const buckets = new Map<ContactRole, CanonicalContact[]>();

  for (const contact of contacts) {
    const existing: CanonicalContact[] = buckets.get(contact.role);

    if (existing) {
      existing.push(contact);
    } else {
      buckets.set(contact.role, [contact]);
    }
  }

  const groups: GroupedContacts[] = [];

  for (const role of GROUP_ORDER) {
    const bucket: CanonicalContact[] = buckets.get(role);

    if (bucket && bucket.length > 0) {
      groups.push({ role, contacts: bucket });
    }
  }

  return groups;
};
